import React, { useState } from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
    display: flex;
    color: #555;
    gap: 10px;
    margin: 10px 0;
    align-items: flex-start;
    input {
        margin-top: 2px;
    }
    label {
        font-size: 10px;
        line-height: 1.4;
        text-align: left;
    }
`;

const AllowDataCheckbox = ({ label_content, onCheckedChange, allow_transfer_default }) => {
    const [checked, setChecked] = useState(allow_transfer_default);

    const allowDataChangeHandler = () => {
        const newChecked = !checked;
        setChecked(newChecked);
        onCheckedChange(newChecked);
    }

    return (
        <CheckboxContainer checked >
            <input type="checkbox" id="allowData" name="allowData" onChange={allowDataChangeHandler} checked={checked} />
            <label htmlFor="allowData" dangerouslySetInnerHTML={{ __html: label_content }}></label>
        </CheckboxContainer>
    );
}

export default AllowDataCheckbox;
